module.exports = __webpack_public_path__ + "img/pendding.f939c6fd.svg";